var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-text mt-3"},[_vm._v("\n    Последняя сработка:\n    "),(_vm.time)?_c('span',{staticClass:"main-text__medium"},[_vm._v(" "+_vm._s(_vm.getTime(_vm.time))+" ")]):_c('span',{staticClass:"main-text__medium"},[_vm._v(" сейчас ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }